import { createReduxAction } from "../../../utils";

export const SET_SELECTED_PACKAGE_ID = "SET_SELECTED_PACKAGE_ID";
export const SET_SELECTED_PAYMENT_METHOD = "SET_SELECTED_PAYMENT_METHOD";
export const SET_RENEWAL_ERROR = "SET_RENEWAL_ERROR";
export const SET_CHECKOUT_ERROR = "SET_CHECKOUT_ERROR";
export const SET_PAYMENT_SESSION = "SET_PAYMENT_SESSION";
export const SET_PROMO_CODE = "PROMO_CODE";
export const SET_PROMO_CODE_ERROR = "SET_PROMO_CODE_ERROR";
export const SET_LOADING_INVOICE_DATA = "SET_LOADING_INVOICE_DATA";
export const SET_LOADING_CHECKOUT_SESSION = "SET_LOADING_CHECKOUT_SESSION";
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";
export const RESET_PAY_FOR_AD_STATE = "RESET_PAY_FOR_AD_STATE";

export const setSelectedPackageId = (payload) =>
  createReduxAction(SET_SELECTED_PACKAGE_ID, payload);

export const setRenewalError = (payload) =>
  createReduxAction(SET_RENEWAL_ERROR, payload);

export const setCheckoutError = (payload) =>
  createReduxAction(SET_CHECKOUT_ERROR, payload);

export const setPaymentSession = (payload) =>
  createReduxAction(SET_PAYMENT_SESSION, payload);

export const setPromoCode = (payload) =>
  createReduxAction(SET_PROMO_CODE, payload);

export const setPromoCodeError = (payload) =>
  createReduxAction(SET_PROMO_CODE_ERROR, payload);

export const setLoadingInvoiceData = (payload) =>
  createReduxAction(SET_LOADING_INVOICE_DATA, payload);

export const setLoadingCheckoutSession = (payload) =>
  createReduxAction(SET_LOADING_CHECKOUT_SESSION, payload);

export const setPaymentMethods = (payload) =>
  createReduxAction(SET_PAYMENT_METHODS, payload);

export const resetPayForAdState = (payload) =>
  createReduxAction(RESET_PAY_FOR_AD_STATE, payload);

export const setSelectedPaymentMethod = (payload) =>
  createReduxAction(SET_SELECTED_PAYMENT_METHOD, payload);
